import JobRunnerModel from "@/common/models/JobRunnerModel";
import axios from "axios";


export default class apiJobRunner {
    static async anyJobsRunning(): Promise<boolean> {

        let response = await axios.post("api/JobRunner/AnyJobsRunning", {            
        });

        return response.data.anyJobs
    }

    static async getAll(): Promise<Array<JobRunnerModel>> {        
        let models = new Array<JobRunnerModel>();
        let response = await axios.post("api/JobRunner/GetAll", {            
        });
        response.data.models.forEach((item : any) => models.push(JobRunnerModel.from(item)))        
        return models
    }

    static async delete(jobRunnerId: String): Promise<void> {

        let response = await axios.post("api/JobRunner/Delete", {
            jobRunnerId: jobRunnerId
        });
        
    }

    static async getUrls(jobRunnerId: String): Promise<Array<string>> {

        let response = await axios.post("api/JobRunner/GetUrls", {
            jobRunnerId: jobRunnerId
        });
                
        return response.data.urls
    }

    static async getLogs(jobRunnerId: String): Promise<void> {

        let response = await axios.post("api/JobRunner/GetLogs", {
            jobRunnerId: jobRunnerId
        });
                
        return response.data.logs
    }

    static async cancel(jobRunnerId: String): Promise<void> {

        let response = await axios.post("api/JobRunner/Cancel", {
            jobRunnerId: jobRunnerId
        });
    }
}